import { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { fetchCampaignManagementSummary } from 'features/views/dashboard/campaignManagement/actions';

import CampaignsTable from './components/CampaignsTable';
import ContactsGraph from './components/ContactsGraph';

export const CampaignManagement = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchCampaignManagementSummary());
	}, [dispatch]);

	return (
		<Paper sx={{ px: 3, py: 2, borderRadius: 1 }}>
			<Stack spacing={2}>
				<SectionHeader
					sx={{ fontWeight: 'bold' }}
					variant="body1"
					text={getMessage('dashboard:campaignManagement.title')}
				/>
				<Grid container>
					<Grid size={12}>
						<Grid container spacing={2}>
							<Grid size={7}>
								<CampaignsTable />
							</Grid>
							<Grid size={5}>
								<ContactsGraph />
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Stack>
		</Paper>
	);
};

export default CampaignManagement;
